import { render, staticRenderFns } from "./downloadPDF.vue?vue&type=template&id=25f6b152"
import script from "./downloadPDF.vue?vue&type=script&lang=js"
export * from "./downloadPDF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports